<template>
  <div class="table-box">
    <global-tag>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="姓名：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.customerName"
                size="primary"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="服务状态：">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="searchObj.entityStatus"
              >
                <el-option label="待签约" :value="1"></el-option>
                <el-option label="在用" :value="2"></el-option>
                <el-option label="注销" :value="3"></el-option>
                <el-option label="拒绝服务" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="手机号码：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.phone"
                size="primary"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="用户类型：">
              <el-select
                v-model="searchObj.customerType"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in userType"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="政府援助信息：" style="margin-left: 10px">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="searchObj.goverInfoId"
              >
                <el-option value="0" label="实体服务"></el-option>
                <el-option value="1" label="信息服务"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="身份证号：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.idCard"
                size="primary"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="类别：" style="margin-left: 10px">
              <el-select
                v-model="searchObj.elderlyBelongCategory"
                placeholder="请选择"
                size="primary"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in oldtypeLits"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="区域名称：" style="margin-left: 10px">
              <el-cascader
                ref="orgId"
                :show-all-levels="false"
                v-model="searchObj.dataId"
                style="width: 100%"
                :options="quyuList"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'label',
                  value: 'orgId',
                }"
                clearable
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属机构：" style="margin-left: 10px">
              <el-select
                v-model="searchObj.serviceStation"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in serviceStationList"
                  :key="item.selectTreeId"
                  :label="item.statName"
                  :value="item.selectTreeId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="本月是否有工单:">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                clearable
                v-model="searchObj.isMouth"
              >
                <el-option label="是" :value="0"></el-option>
                <el-option label="否" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="已服务次数：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.serveNums"
                size="primary"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄区间：" >
               <div style="display:flex">
                <el-input
                clearable
                placeholder="请输入最小年龄"
                v-model="searchObj.ageStart"
                size="primary"
              ></el-input><span style="margin: 0 5px">至</span>
              <el-input
                clearable
                placeholder="请输入最大年龄"
                v-model="searchObj.ageEnd"
                size="primary"
              ></el-input>
               </div>
            </el-form-item>
          </el-col>
          <el-col :span="20">
          <el-form-item label="地址：">
            <el-select
              v-model="searchObj.provinceId"
              placeholder="请选择省"
              @change="handleProvince"
              ref="selectShengChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="searchObj.cityId"
              placeholder="请选择市"
              @change="handleCity"
              ref="selectShiChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="searchObj.areaId"
              placeholder="请选择区"
              @change="handleArea"
              ref="selectQuChange"
              class="address"
            >
              <el-option
                v-for="item in areaList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="searchObj.streetId"
              placeholder="请选择街道"
              @change="streetChange"
              ref="selectJiedaoChange"
              class="address"
            >
              <el-option
                v-for="item in streetList"
                :key="item.addCode"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="searchObj.communityId"
              placeholder="请选择社区"
              ref="selectShequChange"
              @change="handleCommunityChange"
              class="address"
            >
              <el-option
                v-for="item in communityList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="3" :offset="1">
            <el-button type="primary" class="searchBtns" @click="getTableData"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div class="ele-caozuo">
      <el-button
        type="success"
        size="medium"
        icon="el-icon-plus"
        class="openBtns"
        @click="handleTableForm('新增')"
      >
        新增
      </el-button>
      <el-button
        icon="el-icon-upload2"
        class="button downOutBtns"
        type="medium"
        style="margin-left: 10px; color: #fff"
        @click="createwayExcel"
        >导出
      </el-button>
      <el-button
        icon="el-icon-sell"
        class="button modelDownds"
        size="medium"
        type="primary"
        style="margin-left: 10px"
        @click="createExcel"
        >全部导出
      </el-button>
      <!-- <el-button icon="el-icon-edit" type="info" @click="batchClear"
          >清除号码</el-button
      > -->
      <!--      <el-button type="primary" size="medium">导入</el-button>-->
      <!--      <el-button type="primary" size="medium">导出</el-button>-->
    </div>

    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-bottom: 15px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.id
          }
        "
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="70"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <!-- <el-table-column
     prop="fileNumber"
     label="档案号"
     align="center"
     :show-overflow-tooltip="true"
 >
 </el-table-column> -->
        <el-table-column
          prop="customerName"
          label="姓名"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="phone"
          label="手机号码"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="createPersonName"
          label="创建人"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column> -->
        <el-table-column
          prop="customerTypeStr"
          label="用户类型"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="elderlyBelongCategory"
          label="所属类别"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-for="(item, index) in oldtypeLits" :key="index">
              <span v-if="scope.row.elderlyBelongCategory == item.dictCode">{{
                item.dictLabel
              }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="区域名称"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="serviceStationName"
          label="所属机构"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="remainingYearMoney"
          label="年度剩余金额"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="currentMonthPrice"
          label="本月服务累计金额"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="mserveNums"
          label="已完成服务次数"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleTableForm('查看', scope.row.id)"
              >查看
            </el-button>
            <el-button
              type="text"
              @click="handleTableForm('编辑', scope.row.id)"
              >编辑
            </el-button>
            <el-button
              type="text"
              @click="deleteItem(scope.row.id)"
              style="margin-right: 15px"
              >删除
            </el-button>

            <el-popover placement="top-start" width="200" trigger="click">
              <slot>
                <vue-qr
                  ref="qr"
                  :text="String(scope.row.id)"
                  :size="200"
                ></vue-qr>
                <p
                  class="downCode"
                  @click="
                    downloadImg(
                      scope.$index,
                      scope.row.id,
                      scope.row.customerName
                    )
                  "
                >
                  下载
                </p>
              </slot>
              <!-- @click="createCode(scope.row)" -->
              <el-button type="text" slot="reference">二维码 </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConfig.pageNo"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageConfig.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConfig.total"
      >
      </el-pagination>
    </div>

    <AddInfo
      v-if="showAddStatus"
      :setTitle="dialogTitle"
      :show-status.sync="showAddStatus"
      :formData="formData"
      @updateShowStatus="closeWindo"
    ></AddInfo>
    <!-- 清除手机号座机号 -->
    <el-dialog title="是否清除" width="300px" :visible.sync="dialogVisible6">
      <el-checkbox-group v-model="isphone">
        <el-checkbox label="清除手机号"></el-checkbox>
        <el-checkbox label="清除座机号"></el-checkbox>
      </el-checkbox-group>
      <div slot="footer">
        <el-button type="primary" @click="saveClear">确定</el-button>
        <el-button @click="Clears">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr"
import AddInfo from "./info/addInfo.vue"
import headLine from "../components/headline"
import request from "@/utils/request.js"

export default {
  components: {
    AddInfo,
    headLine,
    vueQr,
  },
  data() {
    return {
      isSearchContent: true,
      searchObj: {},
      dialogTitle: "",
      showAddStatus: false,
      formData: {},
      quyuList: [],
      tableData: [],
      oldtypeLits: [],
      serviceStationList: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      vueQrText: "",
      oldData: {},
      dialogVisible6: false,
      isphone: [],
      selectedData: [],
      userType: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: [],
      myMap:null
    }
  },
  created() {
    this.getTableData()
    this.getTree()
    this.getTreeChecked()
    this.getProvince()
    let query = {
      pageNum: 1,
      pageSize: 999,
      dictType: "customer.type",
    }
    this.$http
      .request({
        url: "/rbac/system/dict/data/list",
        method: "get",
        params: query,
      })
      .then((res) => {
        if (res.code == 200) {
          if (res.rows != null) {
            this.oldtypeLits = res.rows
            this.oldtypeLits.forEach((item) => {
              //    / item.dictCode=String(item.dictCode)
            })
          }
        }
      })
    this.getusertypeList()
  },
  inject: ["reload"], //注入
  methods: {
     //获取地址
     getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      // console.log(this.provinceList)
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.searchObj.cityId = ""
      this.searchObj.areaId = ""
      this.searchObj.streetId = ""
      this.searchObj.communityId = ""
      let city = await this.getDistricts(val)
      this.cityList = city.districtList
      // console.log(this.cityList)
    },
    //市级地址发生改变
    async handleCity(val) {
      // console.log(val, "qu")
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.searchObj.areaId = ""
      this.searchObj.streetId = ""
      this.searchObj.communityId = ""
      let area = await this.getStreetList(val)
      this.areaList = area
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
       this.searchObj.streetId = ""
      this.searchObj.communityId = ""
      // val = val.replace(/.$/, "");
   
      let street = await this.getStreetList(val)
      // console.log(1111, this.queryForm.zoneid, val)

      this.streetList = street
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      // console.log(val)
      this.streetList.forEach((item) => {
        if (item.addName == val) {
          // console.log(item, item.addCode)
          this.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: item.addCode,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  return
                } else {
                  this.communityList = res.content
                }
              }
            })
        }
      })
    },
    //街道地址发生变化
    async streetChange(val) {
      // console.log(val)
      this.searchObj.communityId = ""
      this.communityList = await this.getStreetList(val)
      // console.log(1111, this.queryForm.streetid)
      // this.searchObj.servicePgdAddress =
      //   this.searchObj.provinceId +
      //   "-" +
      //   this.searchObj.cityId +
      //   "-" +
      //   this.searchObj.areaId +
      //   "-" +
      //   this.searchObj.streetId
    },
    // 社区
    handleCommunityChange(val) {
      // console.log(val)
      // this.searchObj.servicePgdAddress =
      //   this.searchObj.provinceId +
      //   "-" +
      //   this.searchObj.cityId +
      //   "-" +
      //   this.searchObj.areaId +
      //   "-" +
      //   this.searchObj.streetId +
      //   "-" +
      //   val
      // console.log(1111, this.queryForm.communityName)
      // console.log(this.queryForm.shequid)
      // console.log(this.queryForm.servicePgdAddress)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    downloadImg(index, id, name) {
      let a = document.createElement("a")
      // 下载图名字
      a.download = name
      //url
      a.href = this.$refs.qr.$el.src
      //合成函数，执行下载
      a.dispatchEvent(new MouseEvent("click"))
    },
    Reset() {
      this.reload()
    },
    // 关闭系统
    closeWindo(state) {
      this.showAddStatus = false
      if (state == true) {
        this.getTableData()
      }
    },
    QuerySearch() {},
    handleSelectionChange(data) {
      this.selectedData = data
    },
    getQulist() {
      this.getTree()
    },
    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }

      return childrenEach(treeData, depth)
    },
    //所属机构
    getTreeChecked() {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    saveClear() {
      var val = this.selectedData
      this.isphone.forEach((item) => {
        if (item == "清除手机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/center/customer/info/updatePhone",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "清除成功!",
                  })
                }
              })
            })
          }
        }
        if (item == "清除座机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/center/customer/info/updateFamilyCall",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "清除成功!",
                  })
                }
              })
            })
          }
        }
      })
      this.dialogVisible6 = false
      this.isphone = []
      this.getTableData()
    },
    Clears() {
      this.dialogVisible6 = false
      this.isphone = []
    },
    createExcel() {
      this.request2({
        url: "jjyl/admin/center/customer/info/oldManExport",
        method: "POST",
        excel: true,
        data: {
          ...this.searchObj
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "服务对象管理.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    // 导出
    async createwayExcel() {
      let ids = []
      if (this.selectedData.length > 0) {
        this.selectedData.forEach((item) => {
          ids.push(item.id)
        })
        const res = await this.request2({
          url: "/jjyl/admin/center/customer/info/oldManPartExport",
          method: "POST",
          data: {
            ids: ids,
          },
          responseType: "blob",
        })
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        })
        const fileName = "服务对象管理.xls"
        const linkNode = document.createElement("a")

        linkNode.download = fileName //a标签的download属性规定下载文件的名称
        linkNode.style.display = "none"
        linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() //模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$message.error("请选择服务对象")
      }
    },
    handleTableForm(title, id) {
      this.dialogTitle = title
      this.showAddStatus = true

      if (title != "新增") {
        this.formData = {}
        this.$http
          .request({
            url: "/jjyl/admin/center/customer/info/get",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.formData = res.content
              console.log(this.formData,'this.formData-index')
            }
          })
      } else {
        this.formData = {}
      }
    },
    // 删除某一项
    deleteItem(id) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/jjyl/admin/center/customer/info/deleteById",
              method: "POST",
              data: {
                id,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功")
                loading.close()
                this.getTableData()
              } else {
                loading.close()
              }
            })
        })
        .catch(() => {
          loading.close()
        })
    },

    getTableData() {
      // const loading = this.$loading({
      //     lock: true,
      //     text: "Loading",
      //     spinner: "el-icon-loading",
      //     background: "rgba(0, 0, 0, 0.7)",
      // })
      this.$http
        .request({
          url: "/jjyl/admin/center/customer/info/findList",
          method: "POST",
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize,
            ...this.searchObj,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.tableData = []
              this.pageConfig.total = 0
              loading.close()
            } else {
              this.tableData = res.content.list || []
              this.tableData.forEach((item) => {
                if (
                  item.customerTypeStr != null &&
                  item.customerTypeStr.indexOf("对象") == -1
                ) {
                  //没找到返回-1
                  item.customerTypeStr = ""
                }
              })
              this.pageConfig.total = res.content.count || 0
              //loading.close()
            }
          } else if (res.code == 504) {
            // loading.close()
            this.$message.error("请求超时")
          }
        })
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
.ele-caozuo {
  width: 14%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
}

.operation-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}

.downCode {
  text-align: center;
  cursor: pointer;
}
</style>
